import { baseApi } from 'api/base';
import { EaeuInfo } from 'api/eaeu/types';
import { ObjectTypeId } from 'api/dict/params';

const getEaeuTransactionInformation = async (
  id: string,
  objectTypeId: ObjectTypeId
): Promise<EaeuInfo[]> => {
  const res = await baseApi.get('/eaeu/transaction-information', {
    params: {
      id,
      objectTypeId,
    },
  });
  return res.data;
};

const sendEaeuTransaction = async (
  id: string,
  objectTypeId: ObjectTypeId,
  transactionTypeId: string[]
) => {
  const res = await baseApi.post('/eaeu/process-transactions', undefined, {
    params: {
      id,
      objectTypeId,
      transactionTypeIdList: transactionTypeId?.join(),
    },
  });
  return res.data;
};

const getProducerEaeuTransactionInfo = async (id?: string) => {
  const res = await baseApi.get(
    `/gmp-compliance-producer-business-entity/${id}/eaeu/transaction-information`
  );
  return res.data;
};

const getProducerEaeuTransactions = async (id?: string) => {
  const res = await baseApi.get(`/gmp-compliance-producer-business-entity/${id}`);
  return res.data;
};

export const eaeuApi = {
  getEaeuTransactionInformation,
  sendEaeuTransaction,
  getProducerEaeuTransactionInfo,
  getProducerEaeuTransactions,
};
